<template>
  <div>
    <b-row my="1">
      <b-col md="2">
        <div class="label">Callback User</div>
      </b-col>
      <b-col md="4">
        <div class="text">
          <b-form-select placeholder="Select User"
                         v-model="filter.currentUser"
                         :options="lookups.callbackUsers"
                         value-field="id"
                         text-field="fullName"
                         @change="refreshCalendar"
                         v-if="lookups">

          </b-form-select>
        </div>
      </b-col>
    </b-row>



    <div v-show="loaded" class='callback-calendar'>
      <div class='callback-calendar-main'>
        <FullCalendar class='callback-calendar-main'
                      :options='calendarOptions'
                      ref="fullCalendar">
          <template v-slot:eventContent='arg'>
            <b>{{ arg.timeText }}</b>
            <i>{{ arg.event.title }}</i>
          </template>
        </FullCalendar>
      </div>
    </div>
  </div>

</template>

<script>
  import FullCalendar from '@fullcalendar/vue'
  import dayGridPlugin from '@fullcalendar/daygrid'
  import timeGridPlugin from '@fullcalendar/timegrid'
  import interactionPlugin from '@fullcalendar/interaction'
  import CallbackService from '@/services/Callback.service'
  import moment from 'moment';

  export default {
    name: "CallbackSearch",
    props: ['activeTab', 'lookups'],

    components: {
      FullCalendar
    },
    //created() {
    //  CallbackService.getUsers().then((result) => {
    //    this.users = result.data;
    //    this.users.unshift({ id: null, fullName: "-", disabled: false });
    //  });
    //},
    data: function () {
      return {
        selectedUser: null,
        totalEventsVisable: 0,
        loaded: false,
        height: 723,
        calendarOptions: {
          plugins: [
            dayGridPlugin,
            timeGridPlugin,
            interactionPlugin
          ],
          headerToolbar: {
            left: 'title',
            center: '',
            right: 'prev,next today',
          },
          initialView: 'dayGridMonth',
          events: (info, successCallback) => {
            this.filter.startStr = info.startStr;
            this.filter.endStr = info.endStr;
            CallbackService.callbackCalendar(this.filter).then((result) => {
              if (result.status === 200) {
                successCallback(result.data);
                this.loaded = true;
                this.totalEventsVisable = result.data.length;
              }              
            });

          },
          //eventMouseEnter: this.mouseOver,
          editable: false,
          selectable: true,
          dayMaxEvents: true,
          weekends: true,
          eventClick: this.handleEventClick,
          eventChange: this.moveEvent,
          eventOrder: '-sort,title',
        },
        filter: {
          startStr: null,
          endStr: null,
          currentUser: null
        },
        moveFilter: {
          dateTo: null,
          dateFrom: null,
          callbackPriority: null,
          userId: null
        },
        //users: null,
      }
    },
    watch: {
      activeTab: function () {
        if (this.activeTab == "calendar") {
          this.refreshCalendar().then(() => {
            //calendar does not display right if no events when switching tab so if no events clear the user and refresh again.
            if (this.totalEventsVisable === 0) {
              this.filter.currentUser = null;
              this.refreshCalendar();
            }
          });
        } else {
          this.loaded = false;
        }
      },
    },
    //created() {
    //  CallbackService.getUsers().then((result) => {
    //    var users = result.data;
    //    users.unshift({ id: null, fullName: "-", disabled: false });
    //    this.users = result.data;
    //  });
    //},
    methods: {
      handleEventClick(clickInfo) {
        if (clickInfo.event.extendedProps.view === 1 && clickInfo.event.id > 0) {
          this.filter.currentUser = clickInfo.event.id;
          this.refreshCalendar();
        }
        else if (clickInfo.event.extendedProps.view === 2 && clickInfo.event.id > 0) {
          this.$emit('filterSearch', clickInfo.event.id, this.filter.currentUser, clickInfo.event.startStr)
        }

        //Load Details Modal
      },
      //mouseOver(event) {
      //  //console.log(event);
      //},
      moveEvent(event) {
        this.moveFilter.dateTo = moment(event.event.start).format("yyyy/MM/DD");
        this.moveFilter.dateFrom = moment(event.oldEvent.start).format("yyyy/MM/DD");
        this.moveFilter.callbackPriority = event.event.id;
        this.moveFilter.userId = event.event.extendedProps.userId;
        //var dateTo = moment(event.event.start).format('DD/MM/YYYY');
        //var dateFrom = moment(event.oldEvent.start).format('DD/MM/YYYY')
        if (event.event.extendedProps.view === 2 && confirm("Move " + event.event.extendedProps.callbacks + " callback(s) with Priority " + event.event.extendedProps.callbackPriority + " from " + moment(this.moveFilter.dateFrom).format("DD/MM/yyyy") + " to " + moment(this.moveFilter.dateTo).format("DD/MM/yyyy") + "?")) {
          CallbackService.moveCallBacks(this.moveFilter).then(() => {
            this.refreshCalendar();
          }).catch(() => {
            this.refreshCalendar();
          });
        } else {
          this.refreshCalendar();
        }
      },
      async refreshCalendar() {
        let calendarApi = this.$refs.fullCalendar.getApi()
        return await calendarApi.refetchEvents();
      }
    },
  }
</script>


<style>
  .fc {
    font-size: 0.9em;
  }
  .fc-clickable {
    cursor: pointer;
  }
</style>

